import { message } from 'antd'
import { http } from './interceptor'

/**
 * 封装axios
 * @param {*} url
 * @param {*} data
 * @param {*} type
 * @returns
 */
export default function ajax(url, data = {}, type = 'GET') {
  let promise
  return new Promise((resolve, reject) => {
    if (type === 'GET') {
      promise = http.get(url, {
        params: { ...data },
      })
    } else if (type === 'PUT') {
      promise = http.put(url, data)
    } else if (type === 'DELETE') {
      promise = http.delete(url, data)
    } else if (type === 'PATCH') {
      promise = http.patch(url, data)
    } else {
      promise = http.post(url, data)
    }
    promise
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        message.error('请求出错了：' + error)
      })
  })
}
